import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca uma requisição como "o componente trata o erro".
 *
 * Por padrão o InterceptorHttp resolve os erros NAVEGANDO para fora da tela
 * (401 -> /login, 403 -> /pagina-acesso-negado, 500 -> /pagina-em-manutencao).
 * Isso é o comportamento das telas antigas e continua valendo para elas.
 *
 * O Certicrefi precisa do oposto -- toast em 401/403 e modal em 500, com a tela
 * PERMANECENDO aberta. Marcando a requisição com este token, o interceptor
 * repassa o HttpErrorResponse ao chamador em vez de navegar.
 */
export const TRATAR_ERRO_NO_COMPONENTE = new HttpContextToken<boolean>(() => false);

/** Espalhe no options do HttpClient: `this.http.post(url, body, semTratamentoGlobalDeErro())`. */
export function semTratamentoGlobalDeErro(): { context: HttpContext } {
  return { context: new HttpContext().set(TRATAR_ERRO_NO_COMPONENTE, true) };
}

/**
 * Marca uma requisição ACESSÓRIA: se ela falhar, a tela que o usuário pediu
 * continua de pé.
 *
 * Diferente de TRATAR_ERRO_NO_COMPONENTE, isto NÃO desliga o tratamento de
 * sessão: 401 continua caindo no fluxo padrão (limpa storage -> /login), porque
 * sessão expirada não é "falha acessória" -- é o AC #8 da F-001 US-002.
 * O que fica suprimido são as navegações de 404/403/500, que hoje arrancariam o
 * usuário da tela por causa de uma chamada secundária.
 *
 * Caso de uso original (F-001 US-002, AC #9): `GET /usuario/perfil`, que monta o
 * menu lateral. Com 500 ali, o portal inteiro ia para /pagina-em-manutencao --
 * mesmo com o dashboard perfeitamente utilizável.
 */
export const ERRO_NAO_INTERROMPE_NAVEGACAO = new HttpContextToken<boolean>(() => false);

/** Espalhe no options do HttpClient: `this.http.get(url, semNavegacaoEmFalha())`. */
export function semNavegacaoEmFalha(): { context: HttpContext } {
  return { context: new HttpContext().set(ERRO_NAO_INTERROMPE_NAVEGACAO, true) };
}
